import my from '../components/my';

export default{
    path:'/my',
    component:my,
 
}



// WEBPACK FOOTER //
// ./src/router/my.js